function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M66 4.125a22.687 22.687 0 100 45.374 22.687 22.687 0 000-45.374z",
  fill: "#ED7899"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M74.25 30.938h-16.5a2.063 2.063 0 01-2.063-2.063V24.75c0-1.139.925-2.063 2.063-2.063h16.5c1.138 0 2.063.924 2.063 2.063v4.125a2.063 2.063 0 01-2.063 2.063z",
  fill: "#FFF7F0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M125.812 51.563v33a4.137 4.137 0 01-4.124 4.124H10.312a4.137 4.137 0 01-4.124-4.124v-33a4.137 4.137 0 014.125-4.126h111.375a4.137 4.137 0 014.124 4.126z",
  fill: "#F7CC8F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M33 88.687l-1.032 6.188-4.867 29.205a2.061 2.061 0 01-2.042 1.732h-4.31a2.06 2.06 0 01-2.063-2.186l1.588-28.751.35-6.188H33zm80.313 34.939a2.06 2.06 0 01-2.062 2.186h-4.311a2.062 2.062 0 01-2.042-1.732l-4.867-29.205-1.032-6.188h12.376l.35 6.188 1.588 28.751zM25.706 48.04l-18.108-.37L6.49 78.342 25.706 48.04z",
  fill: "#FFF7F0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M47.438 47.438l-24.75 41.25h20.625l24.75-41.25H47.436zm41.25 0l-24.75 41.25h20.624l24.75-41.25H88.688zm37.124 6.868v30.257a4.137 4.137 0 01-4.124 4.124h-16.5l20.624-34.381z",
  fill: "#FFF7F0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M33 88.688l-1.031 6.187H20.274l.351-6.188H33zm78.726 6.187h-11.695L99 88.687h12.375l.351 6.188z",
  fill: "#EFD8BE"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M78.375 28.875V24.75a4.13 4.13 0 00-4.125-4.125h-16.5a4.13 4.13 0 00-4.125 4.125v4.125A4.13 4.13 0 0057.75 33h16.5a4.13 4.13 0 004.125-4.125zm-20.625 0V24.75h16.5l.002 4.125H57.75z",
  fill: "#8D6C9F"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M121.688 45.375H82.335c5.156-4.538 8.415-11.179 8.415-18.563 0-13.653-11.096-24.75-24.75-24.75S41.25 13.16 41.25 26.813c0 7.384 3.259 14.025 8.415 18.563H10.313c-3.404 0-6.188 2.784-6.188 6.188v33c0 3.403 2.784 6.187 6.188 6.187h8.132l-1.82 32.769a4.142 4.142 0 001.12 3.065 4.14 4.14 0 002.998 1.291h4.325a4.116 4.116 0 004.069-3.446l5.61-33.679H97.25l5.612 33.683a4.118 4.118 0 004.071 3.442h4.325c1.129 0 2.222-.47 2.997-1.291a4.135 4.135 0 001.12-3.063l-1.821-32.771h8.133c3.403 0 6.187-2.784 6.187-6.188v-33c0-3.403-2.784-6.187-6.187-6.187zM45.375 26.812c0-11.364 9.26-20.625 20.625-20.625 11.364 0 20.625 9.261 20.625 20.625 0 8.147-4.764 15.222-11.653 18.563H57.028c-6.889-3.341-11.653-10.416-11.653-18.563zM10.312 49.5H23.17L8.25 74.365V51.563c0-1.135.928-2.063 2.063-2.063zm0 37.125a2.069 2.069 0 01-2.062-2.063v-2.177L27.98 49.5h15.815L21.52 86.625H10.313zm14.752 37.125H20.74l1.835-33h7.988l-5.5 33zm1.266-37.125L48.605 49.5H64.42L46.447 79.456a2.062 2.062 0 001.768 3.124c.701 0 1.384-.356 1.77-1L69.23 49.5h15.815L62.77 86.625H26.33zm61.875 0l11.554-19.258a2.062 2.062 0 10-3.537-2.122l-12.827 21.38H67.58L89.855 49.5h31.833c1.134 0 2.062.928 2.062 2.063v2.177l-19.73 32.885H88.205zm23.052 37.125h-4.325l-5.498-33h7.988l1.835 33zm10.431-37.125H108.83l14.92-24.865v22.803a2.068 2.068 0 01-2.062 2.062z",
  fill: "#8D6C9F"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M55.688 111.375c-1.141 0-2.063.924-2.063 2.063v4.125a2.062 2.062 0 104.125 0v-4.125a2.062 2.062 0 00-2.063-2.063zm10.312 0c-1.14 0-2.063.924-2.063 2.063v4.125a2.062 2.062 0 104.126 0v-4.125A2.062 2.062 0 0066 111.375zm10.313 0c-1.141 0-2.063.924-2.063 2.063v4.125a2.062 2.062 0 104.125 0v-4.125a2.062 2.062 0 00-2.063-2.063zm10.312 0c-1.14 0-2.063.924-2.063 2.063v4.125a2.062 2.062 0 104.126 0v-4.125a2.062 2.062 0 00-2.063-2.063zm10.313 0c-1.141 0-2.063.924-2.063 2.063v4.125a2.062 2.062 0 104.125 0v-4.125a2.062 2.062 0 00-2.063-2.063zm-51.563 0c-1.14 0-2.063.924-2.063 2.063v4.125a2.062 2.062 0 104.126 0v-4.125a2.062 2.062 0 00-2.063-2.063zm-10.313 0c-1.14 0-2.062.924-2.062 2.063v4.125a2.062 2.062 0 104.125 0v-4.125a2.062 2.062 0 00-2.063-2.063zm69.096-51.338l2.797-4.663a2.062 2.062 0 10-3.537-2.122l-2.797 4.663a2.061 2.061 0 103.537 2.122z",
  fill: "#8D6C9F"
});

function Svg404(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

export default Svg404;